module.exports = __webpack_public_path__ + "static/media/상품.cad0dda9.png";